// extracted by mini-css-extract-plugin
export var attachmentListWrapper = "message-module--attachment-list-wrapper--WYsG+";
export var authorLabel = "message-module--author-label--uR+Bk";
export var avatarHolder = "message-module--avatar-holder--uLuhI";
export var contentText = "message-module--content-text--dxJjD";
export var himIsAnOwnerWrapper = "message-module--him-is-an-owner-wrapper--zusjk";
export var imOwnerWrapper = "message-module--im-owner-wrapper--nfXqG";
export var messageWrapper = "message-module--message-wrapper--rsjEF";
export var wrapper = "message-module--wrapper--shl1Q";